import { isMobile, isTablet } from 'react-device-detect';
import { ArticleContent } from '../../../models';

export const containsPdfContent = (content: ArticleContent): boolean =>
  content.components.some((component) => component.file?.pdfContent);

export const downloadPdfContent = async (content: ArticleContent): Promise<void> => {
  const urls: string[] = content.components
    .filter((component) => component.file && component.file.pdfContent)
    .map((component) => component.file!.url);
  for (let i = 0; i < urls.length; i += 1) {
    const anchor = document.createElement('a');
    anchor.href = urls[i];
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.download = '';
    anchor.click();
    if (i !== urls.length - 1) {
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => {
        setTimeout(resolve, 300);
      });
    }
  }
};

export const getSummaryTitleId = (index: number): string => `content-summary-title-${index}`;

export const MINIMUM_PDF_VIEWER_HEIGHT = 600;

export const isPdfViewerSupported = (): boolean => !(isTablet || isMobile);
